import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setForm } from '../../Store/reducers/uiSettings';
import { Back, FLightBookIcon } from '../../HemeIconLibrary';
import HemaForm from '../../components/Formik';

import { FormTitle } from '../../utils';

export const FormContainer = (props) => {
  const dispatch = useDispatch();
  const { cta, formType, formName, formValidation } = props;
  return (
    <div className="h-full z-10 bg-[#00000075] border-[#DEE2E6] fixed top-0 left-0 w-full flex justify-end">
      <div className="max-w-[600px] w-full bg-white screen-height">
        <div className=" px-4 py-2 h-[70px] flex items-center justify-between bg-primary1  border-b">
          <div
            className="cursor-pointer"
            onClick={() => {
              if (props.onFormClose) {
                props.onFormClose();
              }
              dispatch(setForm(false));
            }}
          >
            <Back />
          </div>

          <div className="flex items-center gap-[16px]">
            <p className="font-normal text-lg text-white m-0">
              "Persevere amidst every failure."
            </p>
            <FLightBookIcon />
          </div>
        </div>
        <div className="h-full px-4 py-8 ">
          <HemaForm
            data={formType}
            cta={cta}
            formValidation={formValidation}
            formName={formName}
            {...props}
          />
        </div>
      </div>
    </div>
  );
};

export default FormContainer;
